import * as React from "react"
import { useState } from "react"
import { useAutoAnimate } from "@formkit/auto-animate/react"
import MobileMenu from "./MobileMenu"
import { Link } from "react-router-dom"

const Header = ({ isPromoOver = false, showPrescreen = false, type = "" }) => {
	const [showMenu, setShowMenu] = useState(false)
	const [animationRef] = useAutoAnimate<HTMLDivElement>()
	const [showMobileNav, setShowMobileNav] = useState(false)

	function scrollToAnchor(anchor) {
		setTimeout(() => {
			try {
				const doc: any = document
				const { top } = doc.querySelector(".js-" + anchor).getBoundingClientRect()

				window.scrollTo({
					top: top + window.scrollY - 220,
					left: 0,
					behavior: "smooth",
				})

				try {
					// eslint-disable-next-line
					let dataLayer = window["dataLayer"] || []
					dataLayer.push({ event: "header", link: anchor })
				} catch (e) { }
			} catch (error) { }
		}, 300)
	}

	return (
		<>
			<div ref={animationRef}>{showMenu && <MobileMenu setShowMenu={setShowMenu} isPromoOver={isPromoOver} scrollToAnchor={scrollToAnchor} />}</div>
			<header className=" absolute top-0 z-[12] w-full bg-white md:pb-4">
				<div className="mx-auto grid  grid-cols-1 md:grid-cols-[33%_67%] items-center justify-self-center bg-blue md:bg-white  md:pt-6 w-full max-w-[1800px] ">

					<div className="bg-white pt-2 pb-2 text-center">
						<Link to="/" ><img
							src={process.env.PUBLIC_URL + "/images/alpro/logo.webp"}
							alt=""
							className="w-[80px] md:w-[140px] md:pl-12 mx-auto md:mx-0"
						/></Link>
					</div>
					<div className="text-center md:hidden pt-4 pb-4 ">
						<img
							src={process.env.PUBLIC_URL + "/images/alpro/menu-btn-mobile.png"}
							alt=""
							className="w-[80px] md:hidden mx-auto"
							onClick={() => {
								setShowMobileNav(!showMobileNav)
							}}
						/>
					</div>
					<div className="hidden md:block">
						<Link
							to={process.env.PUBLIC_URL + "/teilnahmebedingungen"}
							className="header-item font-Veener mr-12 text-blue hover:text-orange"
							onClick={() => {
								try {
									// eslint-disable-next-line
									let dataLayer = window["dataLayer"] || []
									dataLayer.push({ event: "header", link: "teilnahmebedingungen" })
								} catch (e) { }
								return setShowMenu(false)
							}}
						>
							Teilnahmebedingungen
						</Link>
						<Link
							to={process.env.PUBLIC_URL + "/faq"}
							className="header-item font-Veener mr-12 text-blue hover:text-orange"
							onClick={() => {
								try {
									// eslint-disable-next-line
									let dataLayer = window["dataLayer"] || []
									dataLayer.push({ event: "header", link: "faq" })
								} catch (e) { }
								return setShowMenu(false)
							}}
						>
							FAQS
						</Link>
						<Link
							to={process.env.PUBLIC_URL + "/kontakt"}
							className="header-item font-Veener mr-4 text-blue hover:text-orange"
							onClick={() => {
								try {
									// eslint-disable-next-line
									let dataLayer = window["dataLayer"] || []
									dataLayer.push({ event: "header", link: "kontakt" })
								} catch (e) { }
								return setShowMenu(false)
							}}
						>
							Kontakt
						</Link>
						<Link
							to={process.env.PUBLIC_URL + "/datenschutz"}
							target="_blank"
							className="header-item font-Veener mr-4 ml-6 text-blue hover:text-orange"
							onClick={() => {
								try {
									// eslint-disable-next-line
									let dataLayer = window["dataLayer"] || []
									dataLayer.push({ event: "header", link: "kontakt" })
								} catch (e) { }
								return setShowMenu(false)
							}}
						>
							Datenschutzbestimmungen
						</Link>
					</div>
					{showMobileNav && (
						<div className="bg-blue pt-6 md:hidden">
							<Link
								to="/teilnahmebedingungen"
								className="header-item-mobile font-Veener  text-white hover:text-orange"
								onClick={() => {
									try {
										// eslint-disable-next-line
										let dataLayer = window["dataLayer"] || []
										dataLayer.push({ event: "header", link: "teilnahmebedingungen" })
									} catch (e) { }
									return setShowMenu(false)
								}}
							>
								Teilnahmebedingungen
							</Link>
							<Link
								to={process.env.PUBLIC_URL + "/faq"}
								className="header-item-mobile font-Veener  text-white hover:text-orange"
								onClick={() => {
									try {
										// eslint-disable-next-line
										let dataLayer = window["dataLayer"] || []
										dataLayer.push({ event: "header", link: "faq" })
									} catch (e) { }
									return setShowMenu(false)
								}}
							>
								FAQS
							</Link>
							<Link
								to={process.env.PUBLIC_URL + "/kontakt"}
								className="header-item-mobile font-Veener  text-white hover:text-orange"
								onClick={() => {
									try {
										// eslint-disable-next-line
										let dataLayer = window["dataLayer"] || []
										dataLayer.push({ event: "header", link: "kontakt" })
									} catch (e) { }
									return setShowMenu(false)
								}}
							>
								Kontakt
							</Link>
							<Link
								to={process.env.PUBLIC_URL + "/datenschutz"}
								target="_blank"
								className="header-item-mobile font-Veener   text-white hover:text-orange"
								onClick={() => {
									try {
										// eslint-disable-next-line
										let dataLayer = window["dataLayer"] || []
										dataLayer.push({ event: "header", link: "kontakt" })
									} catch (e) { }
									return setShowMenu(false)
								}}
							>
								Datenschutzbestimmungen
							</Link>
						</div>
					)}
				</div>
			</header >
		</>
	)
}

export default Header
